import React from 'react'
import { Tag } from 'antd'
import type { MemberStatus } from '../../types'

interface MemberStatusTagProps {
  status: MemberStatus
}

const MemberStatusTag: React.FC<MemberStatusTagProps> = ({ status }) => (
  <Tag
    bordered={false}
    className={`um-refactor__status um-refactor__status--${status.toLowerCase()}`}
  >
    {status}
  </Tag>
)

export default MemberStatusTag
